import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import BoardGamePage from './pages/BoardGamePage';
import ItchGamesPage from './pages/ItchGamesPage';
import AndroidGamesPage from './pages/AndroidGamesPage';
import { WarScholarHomePage } from './pages/WarScholar/app/pages/HomePage';
import { WarScholarOptionsPage } from './pages/WarScholar/app/pages/OptionsPage';
import { WarScholarBookPage } from './pages/WarScholar/app/pages/BookPage';
import { WarScholarCreditsPage } from './pages/WarScholar/app/pages/CreditsPage';
import { WarScholarPlayPage } from './pages/WarScholar/app/pages/PlayPage';
import { WarScholarShopPage } from './pages/WarScholar/app/pages/ShopPage';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />}>
        </Route>
        <Route path="/privacy" element={<PrivacyPage />}>
        </Route>
        <Route path="/boardgame" element={<BoardGamePage />}>
        </Route>
        <Route path="/itchgames" element={<ItchGamesPage />}>
        </Route>
        <Route path="/androidgames" element={<AndroidGamesPage />}>
        </Route>


        {/* WarScholar Routes */}
        <Route path="/warscholar" element={<WarScholarHomePage />}>
        </Route>
        <Route path="/warscholar/book" element={<WarScholarBookPage />}>
        </Route>
        <Route path="/warscholar/credits" element={<WarScholarCreditsPage />}>
        </Route>
        <Route path="/warscholar/play" element={<WarScholarPlayPage />}>
        </Route>
        <Route path="/warscholar/options" element={<WarScholarOptionsPage />}>
        </Route>
        <Route path="/warscholar/shop" element={<WarScholarShopPage />}>
        </Route>


      </Routes>
    </BrowserRouter>

  );
};

export default App;

